module.exports = __webpack_public_path__ + "img/banner.e08724dd.png";